import React from "react";
import { FIELD_TYPE, FORMAT_TIME } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const {
  INPUT,
  SELECT,
  DATE,
  CHECKBOX,
  CODE,
  RADIO_BUTTON,
  RADIO,
  DATE_DAY_INPUT,
} = FIELD_TYPE;

const bhytInfoFields = (onChange?) => {
  const bhytInfoFields: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã thẻ",
      name: "maTheBhyt",
      placeholder: "Nhập",
      css: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 12,
        xl: 12,
      },
      onChange: onChange,
      labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
      // rules: [{ required: true, message: "Mã thẻ là bắt buộc" }],
    },
    {
      type: INPUT,
      label: "Tên trên thẻ",
      name: "hoTenTrenThe",
      placeholder: "Nhập",
      css: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 12,
        xl: 12,
      },
      labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
      // rules: [{ required: true, message: "Tên trên thẻ là bắt buộc" }],
    },
    {
      type: DATE_DAY_INPUT,
      label: "Ngày sinh",
      name: "ngaySinhTrenThe",
      placeholder: "DD/MM/YYYY",
      optionsTime: {
        showTime: false,
        format: FORMAT_TIME.dayFull,
      },
      disableDate: false,
      css: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 12,
        xl: 12,
      },
      labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
      // rules: [{ required: true, message: "Ngày sinh là bắt buộc" }],
    },
    {
      type: INPUT,
      label: "Miễn giảm (%)",
      name: "phanTramMienGiam",
      disable: true,
      placeholder: "Nhập",
      css: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 12,
        xl: 12,
      },
      labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
      wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
    },
    {
      type: INPUT,
      label: "Nơi ĐKKCB",
      name: "noiDkkcbd",
      placeholder: "Nhập",
      css: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 24,
        xl: 24,
      },
      labelCol: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4 },
      wrapperCol: { xs: 20, sm: 20, md: 20, lg: 20, xl: 20 },
      disable: true,
    },
    {
      type: DATE_DAY_INPUT,
      label: "5 năm liền",
      placeholder: "DD/MM/YYYY",
      name: "the5Nam",
      optionsTime: {
        showTime: false,
        format: FORMAT_TIME.dayFull,
      },
      disableDate: false,
      css: {
        xs: 24,
        sm: 24,
        md: 24,
        lg: 16,
        xl: 16,
      },
      labelCol: { xs: 6, sm: 6, md: 6, lg: 6, xl: 6 },
      wrapperCol: { xs: 18, sm: 18, md: 18, lg: 18, xl: 18 },
    },
  ];

  return bhytInfoFields;
};

const bhytInfo2Fields: DataFormField[] = [
  {
    name: ["lyDoVaoVien"],
    type: RADIO,
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
    },
    options: [
      {
        label: "Đúng tuyến",
        value: 1,
      },
      {
        label: "Cấp cứu",
        value: 2,
      },
      {
        label: "Trái tuyến",
        value: 3,
      },
      {
        label: "Thông tuyến",
        value: 4,
      },
    ],
    wrapperCol: { xs: 24, md: 24, sm: 24, lg: 24, xl: 24 },
  },
  {
    type: INPUT,
    label: "Địa chỉ",
    name: "diaChiTrenThe",
    placeholder: "Nhập",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
    },
    labelCol: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4 },
    wrapperCol: { xs: 20, sm: 20, md: 20, lg: 20, xl: 20 },
  },
  {
    type: SELECT,
    label: "Mã khu vực",
    name: "maKhuVuc",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
    },
    labelCol: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4 },
    wrapperCol: { xs: 20, sm: 20, md: 20, lg: 20, xl: 20 },
    options: [
      { value: "k1", label: "K1" },
      { value: "k2", label: "K2" },
      { value: "k3", label: "K3" },
    ],
  },
  {
    type: INPUT,
    label: "Tên đơn vị",
    name: "donVi",
    placeholder: "Nhập",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
    },
    labelCol: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4 },
    wrapperCol: { xs: 20, sm: 20, md: 20, lg: 20, xl: 20 },
  },
  {
    type: INPUT,
    label: "Chức vụ",
    name: "chucVu",
    placeholder: "Nhập",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 24,
      xl: 24,
    },
    labelCol: { xs: 4, sm: 4, md: 4, lg: 4, xl: 4 },
    wrapperCol: { xs: 20, sm: 20, md: 20, lg: 20, xl: 20 },
  },
  {
    type: DATE,
    label: "Thời gian trả thẻ",
    name: "thoiGianTraThe",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 16,
      xl: 16,
    },
    optionsTime: {
      showTime: false,
      format: FORMAT_TIME.dateTime,
    },
    disableDate: false,
    labelCol: { xs: 6, sm: 6, md: 6, lg: 6, xl: 6 },
    wrapperCol: { xs: 18, sm: 18, md: 18, lg: 18, xl: 18 },
  },
];
const bhytInfo3Fields: DataFormField[] = [
  {
    type: DATE,
    label: "Thời gian nhập viện",
    name: "thoiGianNhapVienNoiTru",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    optionsTime: {
      showTime: false,
      format: FORMAT_TIME.dateTime,
    },
    labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
  },
  {
    type: DATE,
    label: "Hiệu lực từ",
    name: "ngayBatDau",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    optionsTime: {
      showTime: false,
      format: FORMAT_TIME.dayFull,
    },
    labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
    disable: true,
  },
  {
    type: DATE,
    label: "Hiệu lực đến",
    name: "ngayKetThuc",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    optionsTime: {
      showTime: false,
      format: FORMAT_TIME.dayFull,
    },
    labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
    // rules: [{ required: true, message: "Hiệu lực đến là bắt buộc" }],
    disable: true,
  },
  {
    type: INPUT,
    label: "Người cập nhập",
    name: "nguoiCapNhatThe",
    placeholder: "Nhập",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    disable: true,
    labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
  },
  {
    type: DATE_DAY_INPUT,
    label: "Ngày cập nhập",
    name: "ngayCapNhatThe",
    placeholder: "DD/MM/YYYY",
    css: {
      xs: 24,
      sm: 24,
      md: 24,
      lg: 12,
      xl: 12,
    },
    disableDate: false,
    labelCol: { xs: 8, sm: 8, md: 8, lg: 8, xl: 8 },
    wrapperCol: { xs: 16, sm: 16, md: 16, lg: 16, xl: 16 },
  },
];
export { bhytInfoFields, bhytInfo2Fields, bhytInfo3Fields };
